export default "__VITE_ASSET__43ynylRS__"